import {ActionTypes} from '../actions';
import createReducer from '../../common/util/createReducer';

const INITIAL_STATE = {
  'loading': false,
  'verifiedInvoicesList': [],
  'verifiedInvoicesListByPage': [],
  'pageSize': 20,
  'pageNumber': 0,
};

const getPage = (list, pageNumber, pageSize) => {
  if (list.length <= pageSize) {
    return [...list];
  }
  if (list.length > (pageSize * (pageNumber + 1))) {
    return [...list].slice(
      (pageSize * pageNumber),
      (pageSize * (pageNumber + 1))
    );
  }
  return [...list].slice(pageNumber * pageSize);
};

export const verifyInvoice = (state, action) => {
  return createReducer(INITIAL_STATE, {
    [ActionTypes.VERIFYING_INVOICE]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.VERIFIED_INVOICE]: (state, action) => ({
      ...state,
      'loading': false,
      'verifiedInvoicesList': action.response.data,
      'verifiedInvoicesListByPage': [...getPage(action.response.data, 0, state.pageSize)],
    }),
    [ActionTypes.VERIFIED_INVOICE_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'verifiedInvoicesList': [],
    }),
    [ActionTypes.CHANGE_VERIFY_INVOICE_LIST_PAGE]: (state, action) => ({
      ...state,
      'pageNumber': action.payload,
      'verifiedInvoicesListByPage': [...getPage(state.verifiedInvoicesList, action.payload, state.pageSize)],
    }),
    [ActionTypes.CHANGE_VERIFY_INVOICE_LIST_PAGE_SIZE]: (state, action) => ({
      ...state,
      'pageSize': action.payload,
      'pageNumber': 0,
      'verifiedInvoicesListByPage': [...getPage(state.verifiedInvoicesList, 0, action.payload)],
    }),
  })(state, action);
};
